import { render, staticRenderFns } from "./CloseTradesTab.vue?vue&type=template&id=4e14f0ce"
import script from "./CloseTradesTab.vue?vue&type=script&lang=js"
export * from "./CloseTradesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports